import { Component, inject, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { RouterOutlet } from '@angular/router';
import { TranslocoDirective, TranslocoService } from '@jsverse/transloco';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { TuiRoot } from '@taiga-ui/core';

@UntilDestroy()
@Component({
  selector: 'pxc-root',
  imports: [RouterOutlet, TuiRoot, TranslocoDirective],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  private readonly appInsights = inject(ApplicationInsights);
  private readonly titleService = inject(Title);
  private readonly translocoService = inject(TranslocoService);
  private readonly title$ =
    this.translocoService.selectTranslate('Mon suivi de plaie');

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  isBrowserIE = window.document.documentMode;

  ngOnInit(): void {
    this.title$.pipe(untilDestroyed(this)).subscribe((translatedTitle) => {
      this.titleService.setTitle(translatedTitle);
    });

    this.appInsights.loadAppInsights();
    this.appInsights.trackPageView();
  }
}
